<section class="nrc-calc">
  <div class="nrc-calc__centered">
    <div class="nrc-calc__divider">
      <span class="nrc-calc__divider-text"
        >Here's What a Typical Roof <br />
        Replacement Costs</span
      >
    </div>

    <div class="nrc-calc__quote-card">
      <p class="nrc-calc__quote-eyebrow">Roofs in your area typically cost</p>
      <p class="nrc-calc__quote-range" aria-label="Typical cost range">
        {{ estimateRange }}
      </p>
      <p class="nrc-calc__quote-sub">Your final cost depends on:</p>
      <ul class="nrc-calc__quote-factors" role="list">
        @for (factor of costFactors; track factor) {
          <li>{{ factor }}</li>
        }
      </ul>
    </div>
  </div>
</section>
